import { isPlainObj } from 'ramda-adjunct';
import { ExternalFilters } from '../types/ExternalFilters';
const FILTER_VALUE_KEY = 'value';

/**
 * Converts EagGrid's internal filter state `{key: {value: X}}` to flat `{key: X}` format.
 *
 * Unlike `unwrapFilterValues`, this function **preserves all values** including
 * `null`, `false`, `undefined`, and empty arrays. It is intended for the
 * `onExternalFilterChange` notification callback where the consumer needs the
 * complete filter state, including explicitly cleared filters.
 *
 * For API request payload (where nulls/falsy should be stripped), use `unwrapFilterValues`.
 *
 * @param filters - Internal store filter state (`Filters` or `Record<string, unknown>`)
 * @returns Flat filter values with all entries preserved
 */
export const unwrapFilterValuesRaw = (filters: Record<string, unknown>): ExternalFilters => Object.fromEntries(Object.entries(filters).map(([key, rawValue]) => {
  const value = isPlainObj(rawValue) && FILTER_VALUE_KEY in (rawValue as Record<string, unknown>) ? (rawValue as Record<string, unknown>)[FILTER_VALUE_KEY] : rawValue;
  return [key, value];
}));